import { prop, required } from '@rxweb/reactive-form-validators';

export class RelationshipContact {
    constructor(entity: Partial<RelationshipContact>) {
        Object.assign(this, entity);
    }

    @required()
    name: string;

    @prop()
    email: string;

    @required()
    position: string;

    @required()
    cellphone: string;

    @prop()
    showAccordeon?: boolean;

    @prop()
    newRegister?: boolean;
}
